module.exports = __webpack_public_path__ + "static/media/depositIcon.974f8789.svg";